<table class="table-primary">
  <thead>
  </thead>
  <tbody class="border-t-1 border-gray-200">
  <tr class="table-row" *ngFor="let rowData of data; let i = index;">
    <td class="text-left integration" scope="row">
      {{IntegrationTypeEnum[rowData.integrationType]}}
    </td>
    <td class="text-left activity w-fit">
      <div class="switch" (click)="toggleSwitch(rowData)" [class.hidden]="rowData.status !== PmsStatusEnum.Ready">
        <!-- use "hidden" rather than ngIf so both images are pre-loaded and we don't get a flicker -->
        <img class="toggle-switch" [class.hidden]="rowData.isActive" src="assets/icons/icon-slide-switch-is-off.svg" alt="inactive" title="Activate"/>
        <img class="toggle-switch" [class.hidden]="!rowData.isActive" src="assets/icons/icon-slide-switch-is-on.svg" alt="active" title="Deactivate"/>
      </div>
      <div class="switch pending integration" [class.hidden]="rowData.status !== PmsStatusEnum.Pending">
        <div class="text">Pending</div>
      </div>
    </td>
  </tr>
  </tbody>
</table>

<!-- CLOSE ACCOUNT DIALOG -->
<app-warning-dialog [show]="showDeactivateIntegrationDialog"
                    header="Are you sure you want to do this?"
                    description="You can reactivate the integration later."
                    acceptBtnText="Yes, deactivate integration"
                    (cancel)="closeDeactivateIntegrationDialog()"
                    (next)="deactivateIntegration()"
></app-warning-dialog>

<app-dialog *ngIf="displayCannotActivateMoreThanOnePmsAtATime"
  [showHeader]="true"
  [header]="'Cannot Activate'"
  [subHeader]="'Only one PMS integration can be active at once.'"
  [maxWidth]="490"
  [minWidth]="450"
  [headerIcon]="'warning'"
  [show]="true">
    <div class="flex justify-end">
        <app-button customClasses="px-4" 
            [text]="'Ok'" class="save-btn" 
            [minWidth]="50"
            (click)="displayCannotActivateMoreThanOnePmsAtATime = false">
        </app-button>
    </div>
</app-dialog>
